import React, {useEffect, useState} from "react";
import {collection, getDocs, limit, query} from "firebase/firestore";
import {firestore, functions} from "../firebase";
import {httpsCallable} from "firebase/functions";
import "../school/School.css";

export default function AdminDashboard() {
  const [stats, setWeeklySales] = useState([]);
  const [askcancel, setAskCancel] = useState([]);
  const [sales, setSales] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCancel, setLoadingCancel] = useState(false);

  const fetchDashboardData = async () => {
    try {
      // 판매 현황 (payments 컬렉션)
      const statsSnapshot = await getDocs(query(
        collection(firestore, "salesstats"),
        limit(7)
      ));
      //       //console.log('46----------------');

      const weeklyStats = statsSnapshot.docs.map(doc => doc.data());
      setWeeklySales(weeklyStats);
      //console.log("47----------------", weeklyStats);

      // 취소 요청
      const askSnapshot = await getDocs(query(
        collection(firestore, "askCancel")
      ));
      //console.log("48----------------", askSnapshot);

      const askcancel = askSnapshot.docs.map(doc => doc.data());
      setAskCancel(askcancel);
      //console.log("47----------------", askcancel);


      // const salesSnapshot = await getDocs(collection(firestore, "payments"));
      // const salesData = salesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // setSales(salesData);

      // // 라이선스 관리 (licenses 컬렉션)
      // const licensesSnapshot = await getDocs(collection(firestore, "licenses"));
      // const licensesData = licensesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // setLicenses(licensesData);

      // // 사용자 관리 (users 컬렉션)
      // const usersSnapshot = await getDocs(collection(firestore, "users"));
      // const usersData = usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // setUsers(usersData);
    } catch (error) {
      console.error("대시보드 데이터 가져오기 오류:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const handleStat = async () => {
    setLoading(true);
    const aggregateFunction = httpsCallable(functions, "aggregateDailySalesManual");

    try {
      const result = await aggregateFunction(); // You can pass data here if needed, e.g., { date: 'YYYY-MM-DD' }
      //console.log("매출 집계 성공:", result.data);
      alert("매출 집계가 완료되었습니다.");

      await fetchDashboardData(); // 🔁 새로 불러오기
    } catch (error) {
      console.error("매출 집계 실패:", error);
      alert("매출 집계에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  // if (loading) {
  //   return <div className="p-4">로딩 중...</div>;
  // }

  const handleCancel = async (order_id) => {
    setLoadingCancel(true);

    try {
      const cancelPaymentFunction = httpsCallable(functions, "cancelPayment");
      const result = await cancelPaymentFunction({
        order_id: order_id
      });
      //console.log("취소 처리 성공:", result.data);
      alert("취소 처리가 완료되었습니다.");
      // Optionally update UI based on the result
    } catch (error) {
      console.error("취소 처리 실패:", error);
      alert("취소 처리에 실패했습니다.");
    } finally {
      setLoadingCancel(false);
      //console.log("49--------------setLoadingCancel ", loadingCancel);
    }
  };

  // if (loadingCancel) {
  //   return <div className="p-4">취소 요청 로딩 중...</div>;
  // }

  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div className="mx-auto">
        <h1 className="text-2xl font-bold mb-6">관리자 대시보드</h1>

        <button
          className="btn-primary w-auto px-6 py-2"
          onClick={handleStat}
          disabled={loading}
        >
          {loading ? "처리 중..." : "매출 집계 생성"}
        </button>

        <h2 className="text-xl font-bold mt-4 mb-4">판매 현황</h2>
        <div className="d-flex justify-content-center flex-wrap  gap-3 mb-4">
          {stats.length > 0 ? (
            stats.map(stat => (
              <div key={stat.date} className="card border rounded p-2 my-1 cursor-pointer">
                <div className="card-body flex justify-between items-center text-sm text-gray-700">
                  <h5 className="card-title">{stat.date}</h5>
                  <div className="card-body">수량 : {stat.count}</div>
                  <div className="card-footer text-danger text-sm pt-0 pb-0">합계 : {stat.total_sales.toLocaleString()}원</div>
                </div>
              </div>
            ))
          ) : (
            <p>판매 내역이 없습니다.</p>
          )}
        </div>

        <h2 className="text-xl font-bold mt-4 mb-4">취소 요청 현황</h2>
        <div className="d-flex justify-content-center flex-wrap gap-3 mb-4">
          <div className="row g-4">
            {askcancel.length > 0 ? (
              askcancel.map(ask => (
                <div key={ask.asked_at} className="col">
                  <div className="card border rounded p-2 my-1 cursor-pointer">
                    <div className="card-body flex justify-between items-center text-sm text-gray-700">
                      <h5 className="card-title">{ask.order_id}</h5>
                      <div className="card-body">상태 : {ask.status}</div>
                    </div>
                  </div>
                  <button
                    className="btn-primary w-auto px-6 py-2"
                    onClick={() => handleCancel(ask.order_id)}
                    disabled={loadingCancel}
                  >
                    {loadingCancel ? "처리 중..." : "취소 요청 처리"}
                  </button>
                </div>

              ))
            ) : (
              <p>취소 요청 내역이 없습니다.</p>
            )}
          </div>
        </div>

      </div>
    </section>
  /*

      {// 판매 현황 }
      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4">판매 현황</h2>
        <div className="bg-white rounded shadow p-4">
          {sales.length > 0 ? (
            sales.map(sale => (
              <div key={sale.id} className="border-b py-2">
                <p>상품명: {sale.item_name}</p>
                <p>금액: {Number(sale.total_amount).toLocaleString()}원</p>
                <p>결제 상태: {sale.status}</p>
              </div>
            ))
          ) : (
            <p>판매 내역이 없습니다.</p>
          )}
        </div>
      </section>

      {// 라이선스 관리 }
      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4">라이선스 관리</h2>
        <div className="bg-white rounded shadow p-4">
          {licenses.length > 0 ? (
            licenses.map(license => (
              <div key={license.id} className="border-b py-2">
                <p>라이선스 키: {license.license_key}</p>
                <p>상태: {license.status}</p>
                <p>만료일: {new Date(license.expires_at.toDate()).toLocaleDateString()}</p>
              </div>
            ))
          ) : (
            <p>라이선스 데이터가 없습니다.</p>
          )}
        </div>
      </section>

      {// 사용자 관리 }
      <section>
        <h2 className="text-xl font-bold mb-4">사용자 관리</h2>
        <div className="bg-white rounded shadow p-4">
          {users.length > 0 ? (
            users.map(user => (
              <div key={user.id} className="border-b py-2">
                <p>이메일: {user.email}</p>
                <p>가입일: {user.createdAt ? new Date(user.createdAt.toDate()).toLocaleDateString() : "알 수 없음"}</p>
              </div>
            ))
          ) : (
            <p>사용자 데이터가 없습니다.</p>
          )}
        </div>
      </section> */

  );
}
